const BASE_PRICING_FAQ = [
  {
    question: "Onde concluo a assinatura?",
    answer:
      "Depois de criar sua conta, a assinatura é feita no workspace da organização, com checkout seguro integrado ao Stripe.",
  },
  {
    question: "Posso mudar de plano depois?",
    answer:
      "Sim. Administradores da organização podem alterar o plano nas configurações de cobrança do workspace.",
  },
] as const;

const PER_PROJECT_FAQ = {
  question: "Qual a diferença entre por projeto e ilimitado?",
  answer:
    "O plano por projeto cobra mensalmente cada projeto ativo. O ilimitado vale a pena quando você costuma manter 7 projetos ou mais ao mesmo tempo.",
};

export function catalogHasPerProjectPlan(
  plans: Array<{
    product: { metadata?: Record<string, string> };
    prices: Array<{ metadata?: Record<string, string> }>;
  }>,
) {
  return plans.some(
    (plan) =>
      plan.product.metadata?.planCode === "per_project" ||
      plan.product.metadata?.billingModel === "per_project" ||
      plan.prices.some(
        (price) =>
          price.metadata?.planCode === "per_project" ||
          price.metadata?.billingModel === "per_project",
      ),
  );
}

export function shouldShowPerProjectFaq(args: {
  billingUnit: "per_user" | "per_project" | null;
  catalogHasPerProject: boolean;
}) {
  if (args.billingUnit === "per_user") return false;
  if (args.billingUnit === "per_project") return true;
  return args.catalogHasPerProject;
}

export function buildPublicPricingFaq(args: {
  trialPeriodDays: number;
  trialRequiresCard: boolean;
  showPerProjectComparison: boolean;
}) {
  const items: Array<{ question: string; answer: string }> = [...BASE_PRICING_FAQ];
  if (args.showPerProjectComparison) items.push(PER_PROJECT_FAQ);
  if (args.trialPeriodDays > 0) {
    const cardSentence = args.trialRequiresCard
      ? "O checkout pede um cartão no início. A cobrança começa quando o teste termina."
      : "O teste começa sem cartão. A cobrança começa quando o teste termina, se você escolher continuar.";
    items.push({
      question: "Há período de teste?",
      answer: `Planos pagos incluem ${args.trialPeriodDays} dias de teste. ${cardSentence}`,
    });
  }
  return items;
}
